import { ThemeManager } from '@federa/solanda-ui/theme'

/**
 * Single shared ThemeManager instance for the whole showcase.
 *
 * Every page (Home, Documentation) imports THIS instance instead of calling
 * ThemeManager.init() again. Multiple init() calls create independent
 * instances that race against each other when applying theme classes to
 * <html>, which is why theme switching broke.
 *
 * storageKey matches the anti-FOUC script in index.html, which reads
 * `solanda-vue-showcase` (theme) and `solanda-vue-showcase-preset` (preset).
 */
export const theme = ThemeManager.init({
  storageKey: 'solanda-vue-showcase',
  defaultPreset: 'solanda',
  defaultTheme: 'system',
  autoApply: true
})

export default theme
